// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";
import { translation } from "../util/translation";

export default function useLocale() {
  const [controller] = useMaterialUIController();
  const { direction } = controller;
  /**
   * @param {keyof translation} key
   */
  const locale = (key) => {
    const res = translation[direction === "ltr" ? "en" : "ar"][key];
    if (!res) {
      throw new Error(`Translation key "${key}" not found {${direction}}`);
    }
    return res;
  };
  return locale;
}
